<!--
to use this component, you need to pass it an email and a size, otherwise it will use the default values
like so:
<profile-icon size="huge" :user="thisUser" />
-->
<template>
  <img
    class="ui avatar image"
    style="margin-right: 0"
    :style="{ height: imgSize, width: imgSize }"
    v-if="user && user.preferences && user.preferences.profilePicture"
    :src="user.preferences.profilePicture"
    :alt="$t('PROFILE_ICON_TITLE')"
  />
  <img
    class="ui avatar image"
    style="margin-right: 0;"
    :style="{ height: imgSize, width: imgSize }"
    :src="gravatarURL"
    @error="setImageError"
    v-else-if="computedEmail && !errorInImage"
    :alt="$t('PROFILE_ICON_TITLE')"
  />
  <!-- Image is only shown when user has an email, else icon is used -->
  <i v-else :class="iconTag" style="margin-right: 0" />
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
import MD5 from 'md5.js'

export default {
  name: 'profileicon',
  props: {
    email: {
      default: ''
    },
    size: {
      default: ''
    },
    user: {
      default: undefined
    }
  },

  data() {
    return {
      errorInImage: false,
      sizeTable: { small: '10px', big: '28px', huge: '56px' }
    }
  },

  computed: {
    gravatarURL() {
      // Function to get the MD5 hash of email, and search for it on gravatar
      return (
        'https://www.gravatar.com/avatar/' +
        new MD5().update(this.computedEmail.trim().toLowerCase()).digest('hex') + // MD5 hashes email
        '?d=retro' // returns random 8-bit style image if email isn't registered at gravatar
      )
    },
    computedEmail() {
      return this.email || (this.user && this.user.email) || ''
    },
    iconTag() {
      return this.size.trim() + ' user circle icon'
    },
    imgSize() {
      return this.sizeTable[this.size.trim()] || '14px'
    }
  },

  methods: {
    setImageError() {
      this.errorInImage = true
    }
  }
}
</script>
